import type { IQBLinkageHandler } from '../types';
import { hasNonEmptyArrayInLayers, metricLikeRemovedFields, patchBoth } from './shared';

type TPercentageRow = { metric: string; table_code?: string };

function prunePercentage(
  list: TPercentageRow[] | undefined,
  removed: Array<{ column_name: string; table_code: string }>,
): TPercentageRow[] | undefined {
  if (!list?.length) {
    return undefined;
  }
  const filtered = list.filter(
    (row) =>
      !removed.some(
        (r) =>
          row.metric === r.column_name &&
          (row.table_code || 't0') === (r.table_code || 't0'),
      ),
  );
  return filtered.length !== list.length ? filtered : undefined;
}

export const columnPercentageHandler: IQBLinkageHandler = {
  id: 'columnPercentage',
  phase: 'prune',
  keys: ['column_percentage'],
  subscribe: ['metricRemoved', 'rawColumnRemoved'],
  apply(changeSet, ctx) {
    if (!hasNonEmptyArrayInLayers(ctx.base, ctx.draft, 'column_percentage')) {
      return;
    }
    const removed = metricLikeRemovedFields(changeSet).map((m) => ({
      column_name: m.column_name,
      table_code: m.table_code || 't0',
    }));
    if (!removed.length) {
      return;
    }
    const baseNext = prunePercentage(
      ctx.base.column_percentage as TPercentageRow[] | undefined,
      removed,
    );
    const draftNext = prunePercentage(
      ctx.draft.column_percentage as TPercentageRow[] | undefined,
      removed,
    );
    return patchBoth(
      baseNext ? { column_percentage: baseNext } : undefined,
      draftNext ? { column_percentage: draftNext } : undefined,
    );
  },
};
